import { render, staticRenderFns } from "./PaymentSummaryPanel.vue?vue&type=template&id=cb2966aa"
import script from "./PaymentSummaryPanel.vue?vue&type=script&lang=js"
export * from "./PaymentSummaryPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports